export const APP_CONSTANTS = {
  APP_NAME: 'AsairfpApp',
  TOKEN_KEY: 'access_token',
  USER_KEY: 'user_data',
  DEFAULT_REDIRECT: '/dashboard'
} as const;
